import React from "react";
import { toast } from "sonner";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { useAdminList } from "@/hooks/useAdminList";
import AdminTable from "@/components/admin/AdminTable";

const STATUS_OPTIONS = [
  { value: "novo", label: "Novo" },
  { value: "contatado", label: "Contatado" },
  { value: "convertido", label: "Convertido" },
  { value: "perdido", label: "Perdido" },
];

const formatDate = (iso) =>
  new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const utmLabel = (row) => {
  const parts = [row.utm_source, row.utm_medium, row.utm_campaign].filter(Boolean);
  return parts.length ? parts.join(" / ") : "—";
};

const COLUMNS = [
  { key: "name", label: "Nome" },
  { key: "company", label: "Empresa", render: (r) => r.company || "—" },
  {
    key: "contato",
    label: "Contato",
    render: (r) => (
      <div className="flex flex-col gap-0.5">
        <a href={`mailto:${r.email}`} className="hover:text-[var(--mn-gold)]">{r.email}</a>
        <a href={`https://wa.me/55${r.phone.replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer" className="text-xs text-[var(--mn-dark)] hover:text-[var(--mn-gold)]">
          {r.phone}
        </a>
      </div>
    ),
  },
  { key: "product", label: "Produto" },
  { key: "quantity", label: "Qtd." },
  {
    key: "message",
    label: "Mensagem",
    render: (r) => (
      <span className="block max-w-[220px] truncate" title={r.message || ""}>
        {r.message || "—"}
      </span>
    ),
  },
  { key: "utm", label: "Origem (UTM)", render: utmLabel },
  { key: "created_at", label: "Recebido em", render: (r) => formatDate(r.created_at) },
];

export default function AdminOrcamentos() {
  const { pin } = useAdminAuth();
  const { items, loading, error, remove, updateStatus } = useAdminList("/quotes", pin);

  const handleDelete = async (row) => {
    if (!window.confirm(`Remover o orçamento de ${row.name}?`)) return;
    try {
      await remove(row.id);
      toast.success("Orçamento removido");
    } catch {
      toast.error("Falha ao remover");
    }
  };

  const handleStatusChange = async (id, status) => {
    try {
      await updateStatus(id, status);
    } catch {
      toast.error("Falha ao atualizar status");
    }
  };

  return (
    <div className="p-6 lg:p-10">
      <div className="mb-6">
        <span className="mn-eyebrow">Orçamentos</span>
        <h2 className="font-serif-display font-extrabold text-2xl text-[var(--mn-black)] mt-3">
          {items.length} orçamento(s) recebido(s)
        </h2>
      </div>
      <AdminTable
        columns={COLUMNS}
        rows={items}
        loading={loading}
        error={error}
        emptyLabel="Nenhum orçamento recebido ainda."
        statusOptions={STATUS_OPTIONS}
        onStatusChange={handleStatusChange}
        onDelete={handleDelete}
        getRowTestId={(r) => `admin-quote-${r.id}`}
      />
    </div>
  );
}
